import { ROTA_APIS } from "@/api_framework/api_config";
import {
  ERRORS,
  IRotaManagementRotaCopyPropsData,
  IRotaManagementRotaCopyResponse,
} from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setRotaerrorIds } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useRotaShiftCopyAPI = () => {
  const configuration = useConfiguration();

  const [AppError, setAppError] = useState<string | null>(null);
  const [resPonse, setResPonse] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (filterParams: IRotaManagementRotaCopyPropsData) => {
      dispatch(
        setLoading({
          key: "isPWLInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(
            ROTA_APIS?.ROTA_SHIFT_COPY_API?.baseURL ?? "",
            filterParams,

            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IRotaManagementRotaCopyResponse>) => {
            if (res.data.status === true) {
              // dispatch(setProvider(res.data.data));
              setResPonse(true);
              toast.success("Schedule Successfully Shifted");
            } else {
              //
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            // if () {
            //   toast.error("Error while fetching patient waiting list");
            // }
            if (e.response.status === 400 || e.code === "ERR_BAD_REQUEST") {
              const d = e.response.data as any;
              setAppError(d.message);
              toast.error("Schedule Shifting Failed");
              const vv = e.response.data as ERRORS;
              dispatch(setRotaerrorIds({ data: vv }));
              dispatch(
                setLoading({
                  key: "isPWLInProgress",
                  status: false,
                }),
              );
            }
            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { AppError, setAppError, execute, resPonse };
};
